export default {"src":"/planning/bridesmaid-dress/quiz/_next/static/media/favicon.1c9489df.ico","height":16,"width":16};